/* Cart discounts use Shopify's locale-aware Ajax Cart API. */
if (!customElements.get('gg-cart-discount')) {
  customElements.define('gg-cart-discount', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.querySelector('form').addEventListener('submit', (event) => this.apply(event), { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async apply(event) {
      event.preventDefault();
      const input = this.querySelector('input');
      const code = input.value.trim();
      if (!code || this.hasAttribute('aria-busy')) return;
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      status.textContent = '';
      this.setAttribute('aria-busy', 'true');
      button.disabled = true;
      const root = window.Shopify?.routes?.root || '/';
      const drawer = this.closest('cart-drawer');
      try {
        const currentResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!currentResponse.ok) throw new Error('Cart unavailable');
        const current = await currentResponse.json();
        const codes = (current.discount_codes || []).filter(entry => entry.applicable).map(entry => entry.code);
        if (!codes.some(existing => existing.toLowerCase() === code.toLowerCase())) codes.push(code);
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(','), sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
        });
        if (!response.ok) throw new Error('Discount update failed');
        const cart = await response.json();
        const applied = (cart.discount_codes || []).some(entry => entry.applicable && entry.code.toLowerCase() === code.toLowerCase());
        const message = applied ? this.dataset.success : this.dataset.invalid;
        if (!cart.sections?.['cart-drawer'] || !cart.sections?.['cart-icon-bubble']) throw new Error('Cart refresh failed');
        drawer.renderContents(cart);
        const next = drawer.querySelector('gg-cart-discount');
        if (next) {
          next.querySelector('[role="status"]').textContent = message;
          if (!applied) {
            const nextInput = next.querySelector('input');
            nextInput.value = code;
            nextInput.setAttribute('aria-invalid', 'true');
          }
          setTimeout(() => next.querySelector('input')?.focus({ preventScroll: true }), 80);
        }
      } catch (error) {
        status.textContent = this.dataset.error;
      } finally {
        this.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }
  });
}
